import { render } from "./AnnoncementIconNew.vue?vue&type=template&id=3537078f"
import script from "./AnnoncementIconNew.vue?vue&type=script&lang=js"
export * from "./AnnoncementIconNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__